<template>
  <el-dialog
    :visible="visible"
    class="msgedit-card"
    :before-close="
      () => {
        visible = false;
      }
    "
  >
    <div class="title">修改个人说明</div>
    <div class="msg-modify">
      <p>个人说明</p>
      <textarea
        v-model="motto"
        :placeholder="motto ? '' : '请输入个人简介'"
      ></textarea>
    </div>
    <div class="btns">
      <button @click="visible = false">取消</button>
      <button @click="save">提交</button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "",
  data() {
    return {
      motto: "",
      visible: false,
    };
  },
  computed: {
    ...mapGetters("home", ["user"]),
  },
  methods: {
    ...mapActions("userInfor", ["setUserDetailInfo"]),
    async save() {
      // await this.setUserDetailInfo({
      //   user_id: this.user.uid,
      //   motto: this.motto
      // })
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.msgedit-card {
  > .el-dialog {
    width: 594px;
    height: 437px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    > .el-dialog__header {
      width: 0;
      height: 0;
      padding: 0 !important;
      margin: 0;
      .el-dialog__close {
        color: rgba(255, 255, 255, 1);
      }
    }
    .el-dialog__body {
      padding: 28px 0 0 28px;
      > .title {
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(48, 48, 48, 1);
        line-height: 26px;
        text-align: left;
      }
      > .msg-modify {
        p {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 19px;
          text-align: left;
          margin: 26px 0 15px 0;
        }
        textarea {
          width: 538px;
          height: 202px;
          padding: 11px 14px 11px 15px;
          margin-left: -25px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 19px;
          outline: none;
          border: 1px solid rgba(234, 234, 234, 1);
        }
      }
      > .btns {
        width: 260px;
        margin-top: 37px;
        margin-left: 124px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        button:nth-child(1) {
          width: 110px;
          height: 38px;
          border-radius: 28px;
          border: 1px solid rgba(231, 0, 18, 1);
          background: rgba(255, 255, 255, 1);
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(231, 0, 18, 1);
          line-height: 28px;
          outline: none;
        }
        button:nth-child(2) {
          width: 110px;
          height: 38px;
          border-radius: 28px;
          border: 1px solid rgba(231, 0, 18, 1);
          background: rgba(231, 0, 18, 1);
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          outline: none;
        }
      }
    }
  }
}
</style>
